import * as React from "react";
import { Popover } from "radix-ui";
import "./styles/Tooltip.scss";

type Props = {
  trigger: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
};

const CLASS_PREFIX = `ws-widgets-tooltip`;

const Tooltip = ({ trigger, onOpenChange, children }: Props) => (
  <Popover.Root onOpenChange={ onOpenChange }>
    <Popover.Trigger className={ `${ CLASS_PREFIX }__trigger` } >
      { trigger }
    </Popover.Trigger>
    <Popover.Content
      className={ `${ CLASS_PREFIX }__content` }
      side={ `top` }
      sideOffset={ 2 }
    >
      { children }
      <Popover.Arrow className={ `${ CLASS_PREFIX }__arrow` } />
    </Popover.Content>
  </Popover.Root>
);

export default Tooltip;
